import HubComparator from './HubComparatorCms';

export default HubComparator;